export enum Articulation {
  HammerOn = 'h',
  PullOff = 'p',
  Slide = 's',
  Bend = 'b',
  BendRelease = 'b',
  Tap = 't',
}
